












module.exports =
  name: 'period_categories'
  props: ['transactions']
  data: ->
    categories:
      included: []
      excluded: []
  mounted: ->
    @$watch 'categories', (=> @$emit 'change', @categories), { deep: true }
  computed:
    available_categories: ->
      res = @$store.getters.transactions_categories
      _.map res, (category) ->
        name: category.name
        value: category.name
        count: category.count
